import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SearchStudent } from '../../_models/search-student/search-student.model';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { ColumnDef } from '../../shared/data-table/data-table.model';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { ClientListing } from '../../_models/clients/client-listing.model';
import { StudentService } from '../../_services/student/student.service';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { ClientListForAddStudentResponse } from '../../_models/clients/client-list-for-add-student-response.model';
import { ClientService } from '../../_services';
import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'send-bulk-student-access-link',
    templateUrl: './send-bulk-student-access-link.component.html',
    styleUrls: ['./send-bulk-student-access-link.component.css'],
    standalone: false
})
export class SendBulkStudentAccessLinkComponent implements OnInit {
  @ViewChild('utilityBarForm', { static: true }) utilityBarForm: TemplateRef<any>;

  public students: Array<SearchStudent> = new Array<SearchStudent>();
  public columns: ColumnDef<SearchStudent>[] = [];
  public emptyMessage: string = "No student(s) Found";

  public searchText: string = "";
  public searchPlaceholder: string = "";
  public studentTooltip: string = "";
  public startDate: Date;
  public endDate: Date;

  public clientList: Array<ClientListing> = new Array<ClientListing>();
  public filteredClientList: Array<ClientListing> = new Array<ClientListing>();
  public selectedClient: ClientListing;

  public StudentSearchClientFilter: boolean = false;

  public selectAllStudentsForSend: boolean = false;
  private selectedStudents: Array<SearchStudent> = new Array<SearchStudent>();

  constructor(
    private router: Router,
    private featureHelperService: FeatureHelperService,
    public dialog: MatDialog,
    private errorModalHelper: ErrorModalHelperService,
    private studentService: StudentService,
    public themeService: ThemeService,
    private clientService: ClientService,
    private successModalHelper: SuccessModalHelperService
  ) { }

  ngOnInit() {
    let featureList = new Array<string>();
    featureList.push("GenerateStudentAccess",
      "StudentSearchClientFilter");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "GenerateStudentAccess")[0].enabled) {
      console.error("User does not have th required permissions to view the tutor reports screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname } });
    }
    if (currentUserFeatures.filter(f => f.feature === "StudentSearchClientFilter")[0].enabled) {
      this.StudentSearchClientFilter = true;
    }

    this.populateClientDropdown();

    this.buildColumns();

    setTimeout(() => {
      this.searchPlaceholder = "Learner Search";
      this.studentTooltip = "Please enter a learner name or Id";
    }, 100);
  }

  private buildColumns(): void {
    const label = "Learner";
    this.emptyMessage = "No " + label + "(s) Found";
    this.columns = [
      { field: 'select', header: '', type: 'template', templateName: 'select', width: '60px' },
      { field: 'studentId', header: label + ' Id', type: 'text' },
      { field: 'studentName', header: label + ' Name', type: 'template', templateName: 'studentName' },
      { field: 'clientName', header: 'Client Name', type: 'template', templateName: 'clientName' },
      { field: 'upn', header: 'UPN', type: 'template', templateName: 'upn' },
      { field: 'mainSubject', header: 'Main Subject', type: 'template', templateName: 'mainSubject' },
      { field: 'yearGroup', header: 'Year Group', type: 'template', templateName: 'yearGroup' },
      { field: 'createdDate', header: 'Created On', type: 'template', templateName: 'createdDate' }
    ];
  }

  public assignCheckbox(student: SearchStudent, event) {
    if (event.checked) {
      this.selectedStudents.push(student);
    } else {
      let selectedIndex = this.selectedStudents.findIndex(s => s.studentId == student.studentId);
      if (selectedIndex != -1) {
        this.selectedStudents.splice(selectedIndex, 1);
      }
    }
  }

  public onAllStudentsSelected(event) {
    this.selectedStudents = new Array<SearchStudent>();
    if (this.selectAllStudentsForSend) {
      this.selectedStudents.push(...this.students);
    }
  }

  public checked(student: SearchStudent) {
    if (student) {
      return this.selectedStudents.find(s => s.studentId === student.studentId);
    } else return false;
  }

  public search(): void {
    this.studentService.searchStudents(this.searchText, this.selectedClient == null ? "" : this.selectedClient.clientId.toString(), 0, false, false).subscribe((response: SearchStudent[]) => {

      if (response == null) {
        this.students = new Array<SearchStudent>();
      } else {
        let holder = response;
        if (this.startDate) {
          let startFiltered = holder.filter(s => {
            if (s.studentDetailItem) {
              let a = new Date(s.studentDetailItem.createdOn).setHours(0, 0, 0, 0) >= this.startDate.setHours(0, 0, 0, 0);
              return a;
            } else return false;
          });
          holder = startFiltered;
        }
        if (this.endDate) {
          let endFiltered = holder.filter(s => {
            if (s.studentDetailItem) {
              return new Date(s.studentDetailItem.createdOn).setHours(0, 0, 0, 0) <= this.endDate.setHours(0, 0, 0, 0);
            } else return false;
          });
          holder = endFiltered;
        }
        this.students = holder;
      }

    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });

  }

  public emailAccessLinks(): void {
    if (this.selectedStudents && this.selectedStudents.length > 0) {

      // The API counts the emails that actually went (learner.signup.email can be off), so its message is the truth (40300).
      this.studentService.sendBulkSignUpEmail(this.selectedStudents.map(student => student.studentId)).subscribe((response: any) => {
        if (response?.successful) {
          this.successModalHelper.show(response.message);
        } else {
          this.errorModalHelper.show(response?.message || "No emails were sent.", { isValidationError: false });
        }
      }, error => {
        this.errorModalHelper.show(error.message, error);
      });
    } else {
      this.errorModalHelper.show("Please select a student first", { isValidationError: true }, "Amendments Required")
    }
  }

  private populateClientDropdown(): void {

    this.clientService.getClientListForAddStudent().subscribe((response: ClientListForAddStudentResponse) => {
      if (response.success) {
        this.clientList = response.clients;
        this.clientList.forEach(c => c.dropdownDisplay = c.clientName + " (" + c.clientId + ")");
        this.filteredClientList = response.clients;
      } else {
        this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", { isValidationError: false });
      }


    }, error => {
      console.error(error);
      this.errorModalHelper.show("An error has occurred. Please try again or contact your administrator.", error);
    });
  }

}
